<template>
    <div id="app">
        <Header
            :routes="routes"
            :profileRoutes="profileRoutes"
            name="clients"
        />

        <div class="content">
            <router-view/>
        </div>

        <Footer
            :routes="[
                { name: 'General About Us', label: $translate.text('nav.footer.about') },
                { name: 'General Conditions', label: $translate.text('nav.footer.conditions') },
                { name: 'General faq', label: $translate.text('nav.footer.help') },
                { name: 'General Contact Us', label: $translate.text('nav.footer.contact') }
            ]"
            name="clients"
            :showLoggedIn="true"
        />
    </div>
</template>
<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'Clients',

    data() {
        return {
            routes: [
                { name: 'Clients Dashboard', label: this.$translate.text('general.dashboard') },
                { name: 'Clients Webshops', label: this.$translate.text('general.webshops') },
                { name: 'Clients Feeds', label: this.$translate.text('general.feeds') },
                { name: 'Clients Connections', label: this.$translate.text('general.connections') },
            ],
            profileRoutes: [
                { name: 'Account', label: this.$translate.text('auth.my_account') },
                { name: 'Client Company', label: this.$translate.text('clients.company') },
                { name: 'Client Company Subscription', label: this.$translate.text('clients.company.subscription') },
                { name: 'Logout', label: this.$translate.text('auth.logout') },
            ],
        };
    },

    components: {
        Header,
        Footer,
    },
};
</script>
<style lang="scss" scoped>
    .content {
        min-height: 100%;
        margin-bottom: -50px;
    }
</style>
